export default function() {
  const permission = this.$can('View', 'PatientMonitor')
  if (!permission) {
    this.setErrorMode()
    this.errorMessage = "You need a permission: 'View a patient monitor' to view this block"
  }
  return permission
}